import React from 'react';
import { adminStats } from '../../mockData';
import { Card } from '../../components/ui/card';
import { Briefcase, Users, FileText, TrendingUp, Building2, UserCheck } from 'lucide-react';

const StatCard = ({ icon: Icon, title, value, subtitle, color }) => (
  <Card className="p-6">
    <div className="flex items-center justify-between mb-4">
      <div className={`p-3 rounded-lg ${color}`}>
        <Icon className="w-6 h-6 text-white" />
      </div>
    </div>
    <h3 className="text-2xl font-bold text-gray-900 mb-1">{value}</h3>
    <p className="text-gray-600">{title}</p>
    {subtitle && <p className="text-sm text-gray-500 mt-2">{subtitle}</p>}
  </Card>
);

const AdminDashboard = () => {
  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Dashboard</h1>
        <p className="text-gray-600">Overview of your platform</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        <StatCard
          icon={Briefcase}
          title="Total Jobs"
          value={adminStats.totalJobs}
          subtitle={`${adminStats.activeJobs} active`}
          color="bg-[#0A3900]"
        />
        <StatCard
          icon={FileText}
          title="Applications"
          value={adminStats.totalApplications}
          subtitle={`${adminStats.pendingApplications} pending`}
          color="bg-[#1A5C0A]"
        />
        <StatCard
          icon={Users}
          title="Total Users"
          value={adminStats.totalUsers}
          subtitle={`+${adminStats.newUsersThisMonth} this month`}
          color="bg-[#082900]"
        />
        <StatCard
          icon={Building2}
          title="Companies"
          value={adminStats.totalCompanies}
          color="bg-[#0A3900]"
        />
        <StatCard
          icon={UserCheck}
          title="Candidates"
          value={adminStats.totalCandidates}
          color="bg-pink-600"
        />
        <StatCard
          icon={TrendingUp}
          title="Growth Rate"
          value="+24%"
          subtitle="vs last month"
          color="bg-orange-600"
        />
      </div>

      {/* Recent Activity */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Jobs</h3>
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center justify-between pb-4 border-b last:border-0">
                <div>
                  <p className="font-medium text-gray-900">Senior AI Engineer</p>
                  <p className="text-sm text-gray-600">Posted 2 hours ago</p>
                </div>
                <span className="text-sm text-[#0A3900]">12 applicants</span>
              </div>
            ))}
          </div>
        </Card>

        <Card className="p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Users</h3>
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center justify-between pb-4 border-b last:border-0">
                <div className="flex items-center gap-3">
                  <img
                    src={`https://i.pravatar.cc/150?img=${i}`}
                    alt="User"
                    className="w-10 h-10 rounded-full"
                  />
                  <div>
                    <p className="font-medium text-gray-900">John Doe</p>
                    <p className="text-sm text-gray-600">Candidate</p>
                  </div>
                </div>
                <span className="text-sm text-gray-500">2h ago</span>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default AdminDashboard;
